<template>
    <div class="max-w-500 mx-auto h-screen bg-a-gray-f7f7f7" data-cy="container_history_getfriend_detail_main">
            <TopBarBack data-cy="btn_history_getfriend_back" @onClickBack="clickBack()"></TopBarBack>
            <div class="font-bold text-18 text-a-blue-2140a6 text-center pt-4 pb-5" data-cy="text_history_getfriend_title">
                {{ lbl.getfriend.title }}
            </div>
            <HistoryGetFriendList></HistoryGetFriendList>
        </div>
</template>
<script>
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
import HistoryGetFriendList from '../component/HistoryGetFriend/HistoryGetFriendList.vue';

export default {
    name: "HistoryGetFriend",
    mixins: [ModalMixin, AuthPageMixin, AuthStatusMixin, LocaleMixin],
    components: {
        TopBarBack,
        HistoryGetFriendList, 
    },
    data: function(){
        return {

        }
    },
    methods: {
        clickBack: function() {
            this.$router.back()
        }
    }
}
</script>